(() => {
  function getSwiperCtor() {
    if (typeof Swiper !== 'undefined') return Swiper;
    if (window.Swiper && window.Swiper.default) return window.Swiper.default;
    return null;
  }

  function init(root = document) {
    const SwiperCtor = getSwiperCtor();
    if (!SwiperCtor) return false;

    const sliders = root.querySelectorAll('.wholesale-cards-mobile-slider');
    if (!sliders.length) return true;

    sliders.forEach((slider) => {
      if (slider.dataset.swiperInitialized) return;
      slider.dataset.swiperInitialized = 'true';

      const paginationEl = slider.querySelector('.swiper-pagination');

      // eslint-disable-next-line no-new
      new SwiperCtor(slider, {
        slidesPerView: 1.5,
        spaceBetween: 16,
        grabCursor: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });
    });

    return true;
  }

  function waitForSwiper(attempt = 0) {
    if (init()) return;
    if (attempt >= 50) return;
    setTimeout(() => waitForSwiper(attempt + 1), 100);
  }

  waitForSwiper();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      waitForSwiper(0);
      init(event.target);
    });
  }
})();
